import { Helmet } from "react-helmet";
import { Outlet, useLocation } from "react-router-dom";
import { useRouterSync } from "src/hooks/useRouterSync";
import { QueryParamProvider } from "use-query-params";
import { ReactRouter6Adapter } from "use-query-params/adapters/react-router-6";

export const RouterWrapper = () => {
  useRouterSync();
  const { pathname } = useLocation();
  const isPrivatePage = /^\/(lk|authorization|admin)(\/|$)/.test(pathname);

  return (
    <QueryParamProvider adapter={ReactRouter6Adapter}>
      {isPrivatePage && (
        <Helmet>
          <meta name="robots" content="noindex, nofollow" />
        </Helmet>
      )}
      <Outlet />
    </QueryParamProvider>
  );
};
